import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "reactstrap";
import ProductCards from "./ProductCards";
import AuthContext from "../../Context/AuthContext";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CommonToastContainer from "../../components/Common/CommonToastContainer";
import { GetParameters } from "../../api/parameterService";
import { insertEnquiry } from "../../api/enquiryService";
import { AddToCart } from "../../api/cartService";
import { useCount } from "../../Context/CountContext";
import FullScreenLoader from "../../components/Common/Loader";
import { useFilters } from "../../Context/FilterContext";
import ProductCardSkeleton from "./ProductCardSkeleton";
import EnquiryModal from "../Enquiry/EnquiryModal";
import CommonPopUpModal from "../../components/Common/CommonPopUpModal";
import '../../assets/css/vaultaccess.css';
import VaultEmptyState from "./VaultEmptyState";
import { motion, useMotionValue, useTransform, animate, AnimatePresence, useAnimation } from "framer-motion";

export default function VaultAccessSection({ loadMore, totalProductCount, currentRecordCounts, isFetching, errorMessage }) {
	const { checkIsUserLoggedIn } = useContext(AuthContext);
	const isLoggedIn = checkIsUserLoggedIn();
	const { selectedFilters, updateFilter, selectedCategory, setSelectedCategory, clearAllFilters, products, hasMore, totalRecordCounts, sort, setSort, markProductInCart, markProductInEnquiry, refetchProducts, } = useFilters();
	const navigate = useNavigate();
	const { fetchCartCount, fetchEnquiryCount } = useCount();
	const [filteredData, setFilteredData] = useState({});
	const [activeFilter, setActiveFilter] = useState(null);
	const [categories, setCategories] = useState([]);
	const [addingProductId, setAddingProductId] = useState(null);
	const [showLoader, setShowLoader] = useState(false);
	const [isSortOpen, setIsSortOpen] = useState(false);
	const [sortOptions, setSortOptions] = useState([]);
	const sortRef = useRef(null);
	const loadMoreRef = useRef(null);
	const isFetchingRef = useRef(false);
	const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
	const [EnquiryItems, setEnquiryItems] = useState([]);
	const [EnquiryRemark, setEnquiryRemark] = useState("");
	const [submittingEnquiry, setSubmittingEnquiry] = useState(false);
	const [isCommonModalOpen, setIsCommonModalOpen] = useState(false);
	const [commonModalMessage, setCommonModalMessage] = useState("");
	const [commonModalPageType, setCommonModalPageType] = useState("");
	const [commonModalTitle, setCommonModalTitle] = useState("");
	const [toasts, setToasts] = useState([]);
	const [selectedPrice, setSelectedPrice] = useState([0, 10000000]);
	const [priceInput, setPriceInput] = useState({ from: 0, to: 10000000 });
	const [selectedGoldWeight, setSelectedGoldWeight] = useState([0, 250]);
	const [goldInput, setGoldInput] = useState({ from: 0, to: 250 });
	const [selectedCarat, setSelectedCarat] = useState([0, 100]);
	const [caratInput, setCaratInput] = useState({ from: 0, to: 100 });
	const isSortInitialized = useRef(false);
	const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
	const [progress, setProgress] = useState(0);
	const handleEnterApply = (e, applyFn) => {
		if (e.key === "Enter") {
			e.preventDefault();
			applyFn();
			e.target.blur();
		}
	};
	const min = 0;
	const max = 10000000;
	const step = 500;
	const minGoldWeight = 0;
	const maxGoldWeight = 250;
	const stepGoldWeight = 1;
	const minCarat = 0;
	const maxCarat = 100;
	const stepCarat = 1;
	const [copied, setCopied] = useState(false);

	const showToast = (toastData) => {
		setToasts(prev => [...prev, { id: Date.now(), ...toastData }]);
	};

	const removeToast = (id) => {
		setToasts(prev => prev.filter(t => t.id !== id));
	};

	const filters = [
		"Metal Tone",
		"Gold Quality",
		"Price",
		"Carat",
		"Gold Weight",
		//"Diamond Shape",
		//"Diamond Quality",
		//"Collection",
		"Item Size",
		"Ring Style"
	];

	const filterMapping = {
		"Metal Tone": "METALTONE",
		"Gold Quality": "GOLDKT",
		Price: "PRICE",
		"Carat": "Carat",
		"Gold Weight": "GOLDWEIGHT",
		//"Diamond Shape": "SHAPE",
		//"Diamond Quality": "QUALITY",
		//"Collection": "COLLECTION",
		"Item Size": "ITEMSIZE",
		"Ring Style": "RING_STYLE"
	};

	const handleMinChange = (e) => {
		const value = Math.min(Number(e.target.value), selectedPrice[1]);
		setSelectedPrice([value, selectedPrice[1]]);
	};

	const handleMaxChange = (e) => {
		const value = Math.max(Number(e.target.value), selectedPrice[0]);
		setSelectedPrice([selectedPrice[0], value]);
	};

	const handleGoldWeightMinChange = (e) => {
		const value = Math.min(Number(e.target.value), selectedGoldWeight[1]);
		setSelectedGoldWeight([value, selectedGoldWeight[1]]);
	};

	const handleGoldWeightMaxChange = (e) => {
		const value = Math.max(Number(e.target.value), selectedGoldWeight[0]);
		setSelectedGoldWeight([selectedGoldWeight[0], value]);
	};

	const handleCaratMinChange = (e) => {
		const value = Math.min(Number(e.target.value), selectedCarat[1]);
		setSelectedCarat([value, selectedCarat[1]]);
	};

	const handleCaratMaxChange = (e) => {
		const value = Math.max(Number(e.target.value), selectedCarat[0]);
		setSelectedCarat([selectedCarat[0], value]);
	};

	const isInitialLoading = isFetching && products.length === 0;
	const isLoadingMore = products.length > 0 && hasMore;

	////For comma seperated multiple category selection filter item size accrdingly in needed in future
	//const sortItemSizes = (sizes = []) => {
	//	return [...sizes].sort((a, b) => {
	//		const getPriority = (name = "") => {
	//			const n = name.toUpperCase();

	//			if (n.includes("US")) return 1;
	//			if (n.includes("IND") || n === "R") return 2;
	//			if (n.includes("INCH")) return 3;
	//			if (n.includes("MM")) return 4;
	//			if (n.includes("AANA")) return 5;

	//			return 99;
	//		};

	//		const priorityDiff =
	//			getPriority(a?.PARANAME) - getPriority(b?.PARANAME);

	//		if (priorityDiff !== 0) return priorityDiff;

	//		return a.PARANAME.localeCompare(
	//			b.PARANAME,
	//			undefined,
	//			{ numeric: true, sensitivity: "base" }
	//		);
	//	});
	//};

	useEffect(() => {
		fetchParameters(selectedCategory || "");
	}, [selectedCategory]);

	async function fetchParameters(category = "") {
		setShowLoader(true);

		try {
			const payload = {
				CategoryList: category || "",
			};

			const res = await GetParameters(payload);
			if (res?.Message?.[0]?.RETURNCODE !== "1") {
				console.error("Error fetching parameters:", res?.Message?.[0]?.RETURNMESSAGE);
				setFilteredData({});
				setCategories([]);
				setSortOptions([]);
				return;
			}
			const params = res?.Parameters || [];
			const sortedParams = [...params].sort((a, b) => Number(a.SEQUENCENO || 0) - Number(b.SEQUENCENO || 0));
			const mapped = Object.keys(filterMapping).reduce((acc, key) => {
				const type = filterMapping[key];
				if (key === "Ring Style") return { ...acc, [key]: [] };
				acc[key] = sortedParams
					.filter(p => p.PARATYPE?.toUpperCase() === type)
					.map(p => ({ label: p.PARANAME, value: p.PARANAME }));
				return acc;
			}, {});
			if (mapped.Price?.length) {
				setSelectedPrice([min, max]);
			}
			setFilteredData(mapped);

			setCategories(sortedParams
				.filter(p => p.PARATYPE?.toUpperCase() === "CATEGORY")
				.map(c => ({
					productId: c.PARANAME,
					name: c.PARANAME.toUpperCase()
				}))
			);
			const sortVals = sortedParams
				.filter(p => p.PARATYPE?.toUpperCase() === "SORT")
				.map(c => ({
					label: c.PARANAME,
					value: c.PARANAME
				}));
			setSortOptions(sortVals);
			if (sortVals.length && !isSortInitialized.current) {

				isSortInitialized.current = true;
			}
		} catch (error) {
			console.error("Failed to fetch parameters:", error);
		} finally {
			setProgress(100);

			setTimeout(() => {
				setShowLoader(false);
				setProgress(0);
			}, 300);
		}
	}

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (sortRef.current && !sortRef.current.contains(e.target)) {
				setIsSortOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	const activeTags = [];
	if (selectedCategory) {
		activeTags.push({ key: `cat-${selectedCategory}`, type: "category", label: selectedCategory });
	}

	const DEFAULTS = {
		Price: {
			min: min,
			max: max
		},
		Carat: {
			min: minCarat,
			max: maxCarat
		},
		"Gold Weight": {
			min: minGoldWeight,
			max: maxGoldWeight
		}
	};

	Object.keys(selectedFilters).forEach(key => {
		const val = selectedFilters[key];
		if (!val) return;

		if (key === "Price" && typeof val === "object") {
			const { from, to } = val;
			const { min, max } = DEFAULTS.Price;
			if (
				Number.isFinite(from) &&
				Number.isFinite(to) &&
				!(from === min && to === max)
			) {
				activeTags.push({
					key: "price-range",
					type: "range",
					filterKey: "Price",
					label: `₹ ${from.toLocaleString()} – ₹ ${to.toLocaleString()}`
				});
			}
			return;
		}

		if (key === "Carat" && typeof val === "object") {
			const { from, to } = val;
			const { min, max } = DEFAULTS.Carat;

			if (
				Number.isFinite(from) &&
				Number.isFinite(to) &&
				!(from === min && to === max)
			) {
				activeTags.push({
					key: "carat-range",
					type: "range",
					filterKey: "Carat",
					label: `${from} – ${to} ct`
				});
			}
			return;
		}
		if (key === "Gold Weight" && typeof val === "object") {
			const { from, to } = val;
			const { min, max } = DEFAULTS["Gold Weight"];

			if (
				Number.isFinite(from) &&
				Number.isFinite(to) &&
				!(from === min && to === max)
			) {
				activeTags.push({
					key: "goldweight-range",
					type: "range",
					filterKey: "Gold Weight",
					label: `${from} – ${to} gm`
				});
			}
			return;
		}
		if (Array.isArray(val) && val.length > 0) {
			val.forEach(v => {
				activeTags.push({
					key: `${key}-${v.value}`,
					type: "filter",
					filterKey: key,
					label: v.label,
					value: v.value
				});
			});
		}
	});

	const removeTag = (tag) => {
		if (tag.type === "category") return setSelectedCategory(null);

		if (tag.type === "range") {
			updateFilter(tag.filterKey, null);
			return;
		}
		updateFilter(
			tag.filterKey,
			selectedFilters[tag.filterKey].filter(x => x.value !== tag.value)
		);
	};

	const resetEnquiryState = () => {
		setEnquiryItems([]);
		setEnquiryRemark("");
		setIsEnquiryOpen(false);
	};

	const copyEnquiryNo = () => {
		if (!isValidEnquiryNo(commonModalTitle)) return;

		navigator.clipboard.writeText(commonModalTitle).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		});
	};

	const isValidEnquiryNo = (val) => {
		if (!val) return false;
		return /^[A-Z]{1,5}\/\d{1,4}\/\d{1,4}$/i.test(val);
	};

	const handleAddToCart = async (product) => {
		setShowLoader(true);
		setAddingProductId(product.Style_ID);
		try {
			const payload = {
				Style_ID: product.Style_ID,
				JewelCode: product.JewelCode,
				StyleNo: product.StyleNo,
				Quantity: "1",
			};
			const res = await AddToCart(payload);
			const messageObj = res?.ZMESSAGE?.[0];
			if (messageObj?.RETURNCODE === "1") {
				markProductInCart(product.Style_ID);
				fetchCartCount();
				showToast({
					title: "Success!",
					message: messageObj.RETURNMESSAGE || "Product added to Cart!",
					type: "success",
				});
			} else {
				showToast({
					title: "Error!",
					message: messageObj?.RETURNMESSAGE || "Failed to add product",
					type: "error"
				});
			}
		} catch (error) {
			console.error(error);
			toast.error("Something went wrong");
		} finally {
			setAddingProductId(null);
			resetEnquiryState();
			setProgress(100);

			setTimeout(() => {
				setShowLoader(false);
				setProgress(0);
			}, 300);
		}
	};

	useEffect(() => {
		if (!showLoader) return;

		let value = 10;
		setProgress(value);

		const interval = setInterval(() => {
			value = Math.min(value + Math.random() * 15, 90);
			setProgress(value);
		}, 400);

		return () => clearInterval(interval);
	}, [showLoader]);

	const openEnquiryModal = (product) => {
		setEnquiryItems(prev => {
			const exists = prev.some(p => p.Style_ID === product.Style_ID);
			if (exists) return prev;

			return [
				...prev,
				{
					Style_ID: product.Style_ID,
					StyleNo: product.StyleNo,
					JewelCode: product.JewelCode,
					Shortdescription: product.Shortdescription,
					MetalQuality: product.MetalQuality,
					MetalTone: product.MetalTone,
					TotalNetWt: product.TotalNetWt,
					Cart_ID: null,
					Qunatity: 1
				}
			];
		});
		setIsEnquiryOpen(true);
	};

	const removeEnquiryItem = (productId) => {
		setEnquiryItems(prev =>
			prev.filter(p => p.Style_ID !== productId)
		);
	};

	const submitEnquiry = async () => {
		if (!EnquiryItems.length) return;
		setSubmittingEnquiry(true);

		const payload = {
			Enquiry_ID: "0",
			EnquiryNo: "",
			Status: "PENDING",
			StatusComment: EnquiryRemark,
			StyleCount: String(EnquiryItems.length),
			Styles: EnquiryItems.map(x => ({
				Style_ID: x.Style_ID,
				StyleNo: x.StyleNo,
				JewelCode: x.JewelCode,
				Cart_ID: x.Cart_ID != null ? String(x.Cart_ID) : ""
			}))
		};

		try {
			const res = await insertEnquiry(payload);
			if (res?.ZMESSAGE?.[0]?.RETURNCODE === "0") {
				console.error("Error inserting enquiry:", res?.ZMESSAGE);
				setCommonModalTitle("Error");
				setCommonModalMessage(res?.ZMESSAGE?.[0]?.MESSAGE || "Failed to create enquiry");
				setCommonModalPageType("error");
				setIsCommonModalOpen(true);
				return;
			}
			const messageObj = res?.EnquiryData?.[0];
			const rawMsg = messageObj?.ReturnMessage || "";
			const normalizedMsg = rawMsg.replace(/\s+/g, " ").trim();
			const enquiryNoMatch = normalizedMsg.match(/Enquiry\s*No\s*=\s*([A-Z0-9/]+)/i);
			const enquiryNo = enquiryNoMatch ? enquiryNoMatch[1] : "Enquiry Created";
			const cleanMessage = normalizedMsg
				.replace(/^\(\d+\)\s*/g, "")
				.replace(/\(Enquiry\s*No\s*=.*?\)/i, "")
				.trim();
			const styleIds = EnquiryItems.map(x => x.Style_ID);
			markProductInEnquiry(styleIds);
			setEnquiryItems([]);
			setEnquiryRemark("");
			setIsEnquiryOpen(false);
			fetchEnquiryCount();
			setCommonModalTitle(enquiryNo);
			setCommonModalMessage(cleanMessage);
			setCommonModalPageType("enquiry");
			setIsCommonModalOpen(true);
		} catch (err) {
			setCommonModalTitle("Error");
			setCommonModalMessage("Something went wrong");
			setCommonModalPageType("error");
			setIsCommonModalOpen(true);
		} finally {
			setSubmittingEnquiry(false);
		}
	};

	useEffect(() => {
		if (!hasMore) return;
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting && !isFetchingRef.current) {
					isFetchingRef.current = true;
					loadMore();
				}
			},
			{ rootMargin: "200px", threshold: 0 }
		);

		if (loadMoreRef.current) observer.observe(loadMoreRef.current);
		return () => observer.disconnect();
	}, [hasMore, loadMore]);

	useEffect(() => {
		isFetchingRef.current = false;
	}, [products.length]);

	useEffect(() => {
		const timer = setTimeout(() => {
			updateFilter("Price", {
				from: selectedPrice[0],
				to: selectedPrice[1]
			});
		}, 400);
		return () => clearTimeout(timer);
	}, [selectedPrice]);

	useEffect(() => {
		const timer = setTimeout(() => {
			updateFilter("Gold Weight", {
				from: selectedGoldWeight[0],
				to: selectedGoldWeight[1]
			});
		}, 400);
		return () => clearTimeout(timer);
	}, [selectedGoldWeight]);

	useEffect(() => {
		const timer = setTimeout(() => {
			updateFilter("Carat", {
				from: selectedCarat[0],
				to: selectedCarat[1]
			});
		}, 400);
		return () => clearTimeout(timer);
	}, [selectedCarat]);

	const JumpCount = React.memo(({ value }) => {
		const count = useMotionValue(value);
		const rounded = useTransform(count, v => Math.round(v));
		const controls = useAnimation();
		const prevValue = useRef(value);

		useEffect(() => {
			if (prevValue.current === value) return;
			animate(count, value, { duration: 0.45, ease: "easeOut" });
			controls.start({ scale: [1, 1.15, 1], transition: { duration: 0.3, ease: "easeInOut" } });
			prevValue.current = value;
		}, [value, controls]);

		return (
			<motion.span initial={{ scale: 1 }} animate={controls} style={{ display: "inline-block", minWidth: "2.5ch", textAlign: "center" }}>
				{rounded}
			</motion.span>
		);
	});

	useEffect(() => {
		setPriceInput({ from: selectedPrice[0], to: selectedPrice[1] });
	}, [selectedPrice]);

	useEffect(() => {
		setGoldInput({ from: selectedGoldWeight[0], to: selectedGoldWeight[1] });
	}, [selectedGoldWeight]);

	useEffect(() => {
		setCaratInput({ from: selectedCarat[0], to: selectedCarat[1] });
	}, [selectedCarat]);

	if (!isLoggedIn) {
		return (
			<section className="vaultaccess-section">
				<div className="container">
					<div className="login-required-message text-center py-5">
						<div className="mb-4">
							<i className="bx bx-lock-alt" style={{ fontSize: "4rem", color: "#6c757d" }}></i>
						</div>
						<h2 className="mb-3">Vault Access Restricted</h2>
						<p className="mb-4 text-muted" style={{ maxWidth: "500px", margin: "0 auto" }}>
							Login to explore our exclusive collection of premium designs.
						</p>
						<div className="d-flex gap-3 justify-content-center">
							<div color="primary" onClick={() => navigate("/login")} Go to Vault Access>
								<Link to="/login" className="primary-button">
									Login
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	return (
		<>
			<section className="vaultaccess-section">
				{isFetching && <FullScreenLoader progress={progress} />}
				<div className="vaultaccess-container container">
					<div className="fliter-section">
						<div className="vaultaccess-header-wrapper container col-12">
							<div className="col-lg-3 d-flex flex-row">
								<h1 className="vaultaccess-heading fw-bold text-start text-primary"> Vault Access </h1>

								{Number(totalProductCount) > 0 && (
									<p className="mb-0">
										{Number(currentRecordCounts) > 0 ? `(${currentRecordCounts} / ${totalProductCount} items)`
											: `(${totalProductCount} items)`
										}
									</p>
								)}
							</div>
							<div className="category-scroll-wrapper col-12 col-lg-9">
								<div className="vaultaccess-categories-scroll">
									<div className="vaultaccess-categories ps-1">
										{categories.map(cat => (
											<button
												key={cat.productId}
												onClick={() => setSelectedCategory(prev => prev === cat.name ? null : cat.name)}
												className={`category-pill ${selectedCategory === cat.name ? "active" : ""}`}
											>
												{cat.name}
											</button>
										))}
									</div>
								</div>
							</div>
						</div>
						<div className="vaultaccess-filters container p-0">
							<Row className="align-items-center p-0">
								<Col xs="12" lg="9" className="d-flex flex-wrap gap-2" >
									{filters.map(filterName => (
										<div
											key={filterName}
											className={`filter-pill ${activeFilter === filterName ? "active" : ""}`}
											onClick={() => setActiveFilter(activeFilter === filterName ? null : filterName)}
										>
											<span>{filterName}</span>
											<i className={`bx bx-chevron-${activeFilter === filterName ? "up" : "down"}`} />
										</div>
									))}
								</Col>

								<Col xs="12" lg="3" className="vaultaccess-action-group">
									<div className="d-flex align-items-center gap-2">
										<span className="sort-label mb-0">Sort by :</span>

										<div className="custom-sort-wrapper">
											<button type="button" className="sort-dropdown" onClick={() => setIsSortOpen(prev => !prev)}>
												{sortOptions.find(o => o.value === sort)?.label || "Select"}
												<i className={`bx bx-chevron-${isSortOpen ? "up" : "down"}`} />
											</button>

											<div className={`custom-dropdown sortDropdown ${isSortOpen ? "show" : ""}`}>
												{sortOptions.map(opt => (
													<button
														key={opt.value}
														type="button"
														className={`dropdown-item fw-semibold ${sort === opt.value ? "active" : ""}`}
														onClick={() => {
															setSort(opt.value);
															setIsSortOpen(false);
														}}
													>
														{opt.label}
													</button>
												))}
											</div>
										</div>
									</div>

									<button
										type="button"
										className="vaultaccess-modify-btn"
										onClick={() => {
											setActiveFilter(null);
											refetchProducts();
											window.scrollTo({ top: 0, behavior: "smooth" });
										}}
									>
										<i className="bx bx-search-alt"></i>
										<span>Search</span>
									</button>
								</Col>

							</Row>
						</div>
						<AnimatePresence mode="wait">
							{activeFilter && (
								<motion.div
									key={activeFilter}
									className="filter-panel-inline container"
									initial={{ height: 0, opacity: 0 }}
									animate={{ height: "auto", opacity: 1 }}
									exit={{ height: 0, opacity: 0 }}
									transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
									style={{ overflow: "hidden" }}
								>
									{activeFilter === "Ring Style" && (
										<input
											type="text"
											className="ring-style-input"
											placeholder="Search Ring Style…"
											value={selectedFilters["Ring Style"] || ""}
											onChange={(e) => updateFilter("Ring Style", e.target.value)}
										/>
									)}
									{activeFilter === "Price" && (
										<div className="price-slider-wrapper">
											<div className="row align-items-start g-3">
												<div className="col-12 col-lg-4 col-md-4 col-sm-4">
													<div className="range-container mt-2">
														<input
															type="range"
															min={min}
															max={max}
															step={step}
															value={selectedPrice[0]}
															onChange={handleMinChange}
															className="range-slider range-min"
														/>
														<input
															type="range"
															min={min}
															max={max}
															step={step}
															value={selectedPrice[1]}
															onChange={handleMaxChange}
															className="range-slider range-max"
														/>
														<div
															className="slider-track"
															style={{ left: `${(selectedPrice[0] / max) * 100}%`, right: `${100 - (selectedPrice[1] / max) * 100}%` }}
														/>
													</div>
													<div className="d-flex justify-content-between mt-2">
														<span className="text-muted">₹ {selectedPrice[0].toLocaleString()}</span>
														<span className="text-muted">₹ {selectedPrice[1].toLocaleString()}</span>
													</div>
												</div>
												<div className="col-12 col-lg-4 col-md-8 col-sm-4">
													<div className="row g-2">
														<div className="col-4">
															<label className="form-label">From (₹)</label>
															<input
																type="number"
																className="form-control"
																value={priceInput.from}
																onChange={(e) => setPriceInput(p => ({ ...p, from: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+priceInput.from || min, min, max);
																	const to = clamp(+priceInput.to || max, from, max);
																	setSelectedPrice([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+priceInput.from || min, min, max);
																		const to = clamp(+priceInput.to || max, from, max);
																		setSelectedPrice([from, to]);
																	})
																}
															/>
														</div>
														<div className="col-4">
															<label className="form-label">To (₹)</label>
															<input
																type="number"
																className="form-control"
																value={priceInput.to}
																onChange={(e) => setPriceInput(p => ({ ...p, to: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+priceInput.from || min, min, max);
																	const to = clamp(+priceInput.to || max, from, max);
																	setSelectedPrice([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+priceInput.from || min, min, max);
																		const to = clamp(+priceInput.to || max, from, max);
																		setSelectedPrice([from, to]);
																	})
																}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}
									{activeFilter === "Gold Weight" && (
										<div className="price-slider-wrapper">
											<div className="row align-items-start g-3">
												<div className="col-12 col-lg-4 col-md-6">
													<div className="range-container mt-2">
														<input
															type="range"
															min={minGoldWeight}
															max={maxGoldWeight}
															step={stepGoldWeight}
															value={selectedGoldWeight[0]}
															onChange={handleGoldWeightMinChange}
															className="range-slider range-min"
														/>
														<input
															type="range"
															min={minGoldWeight}
															max={maxGoldWeight}
															step={stepGoldWeight}
															value={selectedGoldWeight[1]}
															onChange={handleGoldWeightMaxChange}
															className="range-slider range-max"
														/>
														<div
															className="slider-track"
															style={{ left: `${(selectedGoldWeight[0] / maxGoldWeight) * 100}%`, right: `${100 - (selectedGoldWeight[1] / maxGoldWeight) * 100}%` }}
														/>
													</div>
													<div className="d-flex justify-content-between mt-2">
														<span className="text-muted"> {selectedGoldWeight[0]} gm </span>
														<span className="text-muted"> {selectedGoldWeight[1]} gm </span>
													</div>
												</div>
												<div className="col-12 col-lg-6 col-md-6">
													<div className="row g-2">
														<div className="col-4">
															<label className="form-label">From (gm)</label>
															<input
																type="number"
																className="form-control"
																value={goldInput.from}
																onChange={(e) => setGoldInput(p => ({ ...p, from: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																	const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																	setSelectedGoldWeight([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																		const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																		setSelectedGoldWeight([from, to]);
																	})
																}
															/>
														</div>
														<div className="col-4">
															<label className="form-label">To (gm)</label>
															<input
																type="number"
																className="form-control"
																value={goldInput.to}
																onChange={(e) => setGoldInput(p => ({ ...p, to: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																	const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																	setSelectedGoldWeight([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																		const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																		setSelectedGoldWeight([from, to]);
																	})
																}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}
									{activeFilter === "Carat" && (
										<div className="price-slider-wrapper">
											<div className="row align-items-start g-3">
												<div className="col-12 col-lg-4">
													<div className="range-container mt-2">
														<input
															type="range"
															min={minCarat}
															max={maxCarat}
															step={stepCarat}
															value={selectedCarat[0]}
															onChange={handleCaratMinChange}
															className="range-slider range-min"
														/>
														<input
															type="range"
															min={minCarat}
															max={maxCarat}
															step={stepCarat}
															value={selectedCarat[1]}
															onChange={handleCaratMaxChange}
															className="range-slider range-max"
														/>
														<div
															className="slider-track"
															style={{ left: `${(selectedCarat[0] / maxCarat) * 100}%`, right: `${100 - (selectedCarat[1] / maxCarat) * 100}%` }}
														/>
													</div>
													<div className="d-flex justify-content-between mt-2">
														<span className="text-muted"> {selectedCarat[0]} ct </span>
														<span className="text-muted"> {selectedCarat[1]} ct </span>
													</div>
												</div>
												<div className="col-12 col-lg-6">
													<div className="row g-2">
														<div className="col-4">
															<label className="form-label">From (ct)</label>
															<input
																type="number"
																className="form-control"
																value={caratInput.from}
																onChange={(e) => setCaratInput(p => ({ ...p, from: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																	const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																	setSelectedCarat([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																		const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																		setSelectedCarat([from, to]);
																	})
																}
															/>
														</div>
														<div className="col-4">
															<label className="form-label">To (ct)</label>
															<input
																type="number"
																className="form-control"
																value={caratInput.to}
																onChange={(e) => setCaratInput(p => ({ ...p, to: e.target.value }))}
																onBlur={() => {
																	const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																	const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																	setSelectedCarat([from, to]);
																}}
																onKeyDown={(e) =>
																	handleEnterApply(e, () => {
																		const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																		const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																		setSelectedCarat([from, to]);
																	})
																}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}

									{activeFilter !== "Ring Style" &&
										activeFilter !== "Price" &&
										activeFilter !== "Gold Weight" &&
										activeFilter !== "Carat" && (
											<div className="filter-grid-inline">
												{(() => {
													const options = filteredData[activeFilter] || [];
													const selectedValues = selectedFilters[activeFilter] || [];

													const allSelected =
														options.length > 0 &&
														selectedValues.length === options.length;

													return (
														<>
															<div className="form-check filter-option select-all-option">
																<input
																	type="checkbox"
																	className="form-check-input"
																	id={`select-all-${activeFilter}`}
																	checked={allSelected}
																	onChange={() => {
																		if (allSelected) {
																			updateFilter(activeFilter, []);
																		} else {
																			updateFilter(activeFilter, [...options]);
																		}
																	}}
																/>
																<label
																	htmlFor={`select-all-${activeFilter}`}
																	className="form-check-label fw-bold text-primary"
																>
																	{allSelected ? "Deselect All" : "Select All"}
																</label>
															</div>

															{options.map(opt => {
																const checked = selectedValues.some(
																	v => v.value === opt.value
																);

																return (
																	<div key={opt.value} className="form-check filter-option">
																		<input
																			id={`filter-${activeFilter}-${opt.value}`}
																			className="form-check-input"
																			type="checkbox"
																			checked={checked}
																			onChange={() => {
																				updateFilter(
																					activeFilter,
																					checked
																						? selectedValues.filter(x => x.value !== opt.value)
																						: [...selectedValues, opt]
																				);
																			}}
																		/>
																		<label
																			htmlFor={`filter-${activeFilter}-${opt.value}`}
																			className={`form-check-label ${checked ? "fw-bold" : ""
																				}`}
																		>
																			{opt.label}
																		</label>
																	</div>
																);
															})}
														</>
													);
												})()}
											</div>
										)}
								</motion.div>
							)}
						</AnimatePresence>
						<div className="container selected-tags-wrapper">
							{activeTags.length > 0 && (
								<button className="clear-all-btn" onClick={clearAllFilters}>
									Clear All ×
								</button>
							)}
							{activeTags.map(tag => (
								<div key={tag.key} className="selected-tag">
									{tag.label} <span className="ms-1" onClick={() => removeTag(tag)}> ×</span>
								</div>
							))}
						</div>
					</div>

					{isInitialLoading && (
						<div className="vaultaccess-products">
							{Array.from({ length: 8 }).map((_, i) => (
								<ProductCardSkeleton key={`init-${i}`} />
							))}
						</div>
					)}

					{!isFetching && products.length === 0 && (
						<VaultEmptyState
							title="No Vault Access Available"
							description={
								errorMessage ||
								"There are currently no designs available based on your selected filters. Please try adjusting your filters or check back again later."
							}
							showButton={false}
						/>
					)}

					{products.length > 0 && (
						<div className="vaultaccess-products">
							{products.map(item => (
								<ProductCards
									key={`${item.Style_ID}-${item.Rno}`}
									Style_ID={item.Style_ID}
									Image={item.Image1}
									Line1={item.Line1}
									Line2={item.Line2}
									LineAmount={item.LineAmount}
									LineDiscount={item.LineDiscount}
									PriceRemark={item.PriceRemark}
									StyleNo={item.StyleNo}
									IS_AddedInCart={item.IS_AddedInCart}
									IS_AddedInEnquiry={item.IS_AddedInEnquiry}
									NewArrivalStatus={item.NewArrivalStatus}
									Status={item.Status}
									addingToCart={addingProductId === item.Style_ID}
									handleAddToCart={() => handleAddToCart(item)}
									onEnquiry={() => openEnquiryModal(item)}
								/>
							))}

							{isLoadingMore &&
								Array.from({ length: 3 }).map((_, i) => (
									<ProductCardSkeleton key={`more-${i}`} />
								))}

							<div ref={loadMoreRef} style={{ height: 1 }} />
						</div>
					)}
				</div>
			</section>

			<EnquiryModal
				isOpen={isEnquiryOpen}
				toggle={resetEnquiryState}
				items={EnquiryItems}
				remark={EnquiryRemark}
				setRemark={setEnquiryRemark}
				onRemoveItem={removeEnquiryItem}
				onSubmit={submitEnquiry}
				submitting={submittingEnquiry}
				title="Product Enquiry"
			/>

			<CommonPopUpModal
				isOpen={isCommonModalOpen}
				onClose={() => setIsCommonModalOpen(false)}
				message={commonModalMessage}
				pageType={commonModalPageType}
				title={
					commonModalPageType === "enquiry" ? (
						<>
							<div className="popup-subtitle">
								Thanks for reaching out to us.
							</div>

							<div className="popup-enquiry-label">
								Your Enquiry No is
							</div>

							<div
								className={`popup-enquiry-no ${isValidEnquiryNo(commonModalTitle) ? "copyable" : ""}`}
								onClick={copyEnquiryNo}
								title={isValidEnquiryNo(commonModalTitle) ? "Click to copy" : ""}
							>
								<span>{commonModalTitle}</span>

								{isValidEnquiryNo(commonModalTitle) && (
									<span className={`copy-wrapper ${copied ? "copied" : ""}`}>
										<i className="bx bx-copy copy-icon" />
										{copied && (
											<span className="copied-tooltip">
												Copied!
											</span>
										)}
									</span>
								)}
							</div>
						</>
					) : (
						commonModalTitle
					)
				}
			/>

			<ToastContainer />

			<CommonToastContainer toasts={toasts} removeToast={removeToast} />
		</>
	);
}
